import { getRouteByPath } from '@/routes';

/**
 * Resolves the screen code for a given URL pathname.
 * If the matched route has a code, it is returned directly.
 * If not (sub-route like "crear" or ":employeeId"), follows parentPath to find the parent code.
 */
export function resolveScreenCode(pathname: string): string | null {
  const route = getRouteByPath(pathname);
  if (!route) return null;
  if (route.code) return route.code;

  if (route.breadcrumb.parentPath) {
    const parentRoute = getRouteByPath(route.breadcrumb.parentPath);
    if (parentRoute?.code) return parentRoute.code;
  }

  return null;
}
